module.exports = __webpack_public_path__ + "static/img/LiLiang.2857206.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/contact/LiLiang.jpg
// module id = oBZp
// module chunks = 1